import { render, staticRenderFns } from "./CustomOnboarding.vue?vue&type=template&id=4bce40d5&scoped=true"
import script from "./CustomOnboarding.vue?vue&type=script&lang=js"
export * from "./CustomOnboarding.vue?vue&type=script&lang=js"
import style0 from "./CustomOnboarding.vue?vue&type=style&index=0&id=4bce40d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce40d5",
  null
  
)

export default component.exports